import React from 'react';
import TestResultDisplay from '../common/TestResultDisplay';

interface CarerSupportTestResultProps {
  supportNeedsMet: boolean;
  hasConfidence: boolean;
  negativeImpacts: {
    physical: boolean;
    mental: boolean;
    financial: boolean;
    social: boolean;
  };
  className?: string;
}

const CarerSupportTestResult: React.FC<CarerSupportTestResultProps> = ({
  supportNeedsMet,
  hasConfidence,
  negativeImpacts,
  className = ''
}) => {
  // 🚨 调试标记 - CarerSupportTestResult 组件已加载 🚨
  console.log('🚨🚨🚨 CarerSupportTestResult 组件已加载 - 2025-08-30 🚨🚨🚨');
  console.log('🔥 supportNeedsMet:', supportNeedsMet);
  console.log('🔥 hasConfidence:', hasConfidence);
  console.log('🔥 negativeImpacts:', negativeImpacts);

  // 计算负面影响的数量
  const impactCount = Object.values(negativeImpacts).filter(Boolean).length;
  const overallPositive = supportNeedsMet && hasConfidence && impactCount === 0;


  const testGroups = [
    {
      title: '照护支持充分性评估',
      passed: supportNeedsMet,
      items: [
        {
          name: '支持充分性',
          passed: supportNeedsMet,
          userAnswer: supportNeedsMet ? '支持充分' : '支持不足'
        }
      ]
    },
    {
      title: '照护信心评估',
      passed: hasConfidence,
      items: [
        {
          name: '照护信心',
          passed: hasConfidence,
          userAnswer: hasConfidence ? '有信心' : '缺乏信心'
        }
      ]
    },
    {
      title: '照护负担影响评估',
      score: { current: 4 - impactCount, total: 4 },
      passed: impactCount === 0,
      items: [
        {
          name: '身体健康影响',
          passed: !negativeImpacts.physical,
          userAnswer: negativeImpacts.physical ? '有负面影响' : '无明显影响'
        },
        {
          name: '心理健康影响',
          passed: !negativeImpacts.mental,
          userAnswer: negativeImpacts.mental ? '有负面影响' : '无明显影响'
        },
        {
          name: '经济状况影响',
          passed: !negativeImpacts.financial,
          userAnswer: negativeImpacts.financial ? '有负面影响' : '无明显影响'
        },
        {
          name: '社交生活影响',
          passed: !negativeImpacts.social,
          userAnswer: negativeImpacts.social ? '有负面影响' : '无明显影响'
        }
      ]
    }
  ];

  return (
    <TestResultDisplay
      title="照护者支持评估结果"
      subtitle={`综合评估: ${overallPositive ? '照护支持状况良好' : '照护者需要额外支持'}`}
      testGroups={testGroups}
      className={className}
    />
  );
};

export default CarerSupportTestResult;